import { Color3 } from "@babylonjs/core/Maths/math.color";
import { Mesh } from "@babylonjs/core/Meshes/mesh";
import { CreateLines } from "@babylonjs/core/Meshes/Builders/linesBuilder";
import { CreateRibbon } from "@babylonjs/core/Meshes/Builders/ribbonBuilder";
import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { VertexBuffer } from "@babylonjs/core/Buffers/buffer";
import { Area2D } from '../../tool/tools';
import { ElementGeometry } from "./ElementGeometry";
import { Util } from "../../utils/Util";
import { ShadowGenerator } from "@egr/wcf/modules/core/rendering/ShadowGenerator";
import { clamp } from "@egr/wcf/modules/utils/math";
import { newError } from '@egr/wcf/modules/utils/error';
export class Circle extends ElementGeometry {
    constructor(pRoomManager, pElement) {
        super(pRoomManager, pElement);
        this.mRoomElement = pElement;
        this.mRoomManager = pRoomManager;
        this.mPoints = new Array();
        this.mWidth = 0;
        this.mDepth = 0;
        this.mDiameter = 0;
        this.mMaterial = -1;
        this.mCenter = new Vector2(0, 0);
        this.mminPoint = new Vector2(0, 0);
        this.mmaxPoint = new Vector2(0, 0);
        this.mArea = 0;
        this.mPerimeter = 0;
        this.mHillPoints_Top = null;
        this.mHillPoints_Bottom = null;
        this.mHillPoints_Base = null;
        this.mcanCreateHill = false;
        this.mRoomElement.Params.ElementPoints = new Array();
        this.mRoomElement.Params.ElementOriginalPoints = new Array();
        this.mRoomElement.Params.material = this.mRoomElement.material;
        this.mRoomElement.Params.materialColor = this.getInitialParams().color;
    }
    getType() {
        return ("Circle");
    }
    setMesh(pMesh) {
        this.mArea = Util.calcMeshArea(pMesh) * 0.25;
    }
    getPoints() {
        return this.mPoints;
    }
    getPolygon(pOffset = true) {
        // let tpolygonPoints: Array<Vector3> = [];
        // let tsplinePoints = Util.to3dArray(this.circlePointList());
        // for (let tP of tsplinePoints){
        //     let tnodePos = new Vector3(0,0,0);
        //     if (pOffset)
        //         tnodePos = this.mRoomElement.position.clone();
        //     let tnP = tP.add(tnodePos);
        //     tpolygonPoints.push(tnP);
        // }
        // return (tpolygonPoints);
        let tRes = new Array();
        let tDist = Vector3.Distance(this.mPoints[0], this.mPoints[1]);
        let tRadius = tDist > 0 ? tDist : 0.001;
        const tCAG = CAG.circle({ radius: tRadius, resolution: 60 });
        const tpoints = tCAG.toPoints();
        for (let tP of tpoints) {
            tRes.push(new Vector3(tP.x, 0, tP.y));
        }
        return (tRes);
    }
    width() {
        return this.mWidth;
    }
    depth() {
        return this.mDepth;
    }
    diameter() {
        return this.mDiameter;
    }
    material() {
        return this.mMaterial;
    }
    center() {
        return this.mCenter;
    }
    minPoint() {
        return this.mminPoint;
    }
    maxPoint() {
        return this.mmaxPoint;
    }
    showInteractors(pShow) {
        if (this.mInteractors != null)
            this.mInteractors.showInteractors(pShow);
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 0.0;
        tParams.height = 0.0;
        tParams.floorOffset = 0.0;
        tParams.color = "#999999";
        return (tParams);
    }
    getparent() {
        return (this.mParent);
    }
    get Area() {
        return (this.mArea);
    }
    get Perimeter() {
        return (this.mPerimeter);
    }
    setNewRadius(pNewRadius) {
        let tValue = clamp(pNewRadius, 0.05, 500.0);
        let tCPoints = this.getPoints();
        let tradLine = tCPoints[1].subtract(tCPoints[0]);
        tradLine.normalize();
        tradLine = tradLine.scale(tValue);
        tCPoints[1] = tCPoints[0].add(tradLine);
        let tCnewPoints = new Array();
        tCnewPoints.push(tCPoints[0]);
        tCnewPoints.push(tCPoints[1]);
        this.setPoints(tCnewPoints);
    }
    create2dGeometry(pParent) {
        this.mParent = pParent;
        let tCircle = this.createCircle(pParent);
        //this.drawRadiusLine(pParent);
        if (tCircle != null) {
            //this.prepare2dMesh(tCircle);
            this.mRoomElement.setMesh2d(tCircle);
            this.calcLenght(this.mRoomElement.Params.ElementPoints);
            this.calcSize(this.mRoomElement.Params.ElementPoints);
        }
        let tHill = this.createHill(pParent);
        this.mergeShapeMeshes(pParent, this.mRoomElement.setMesh2d);
    }
    create3dGeometry(pParent) {
        let tCircle = this.createCircle(pParent);
        //this.drawRadiusLine(pParent);
        if (tCircle != null) {
            //this.prepare3dMesh(tCircle);
            this.mRoomElement.setMesh3d(tCircle);
        }
        let tHill = this.createHill(pParent);
        this.mergeShapeMeshes(pParent, this.mRoomElement.setMesh3d);
    }
    getProperties() {
        let tProperties = new Array();
        return (tProperties);
    }
    serializeIOData() {
        return (this.mRoomElement.Params);
    }
    loadIOData(pData) {
        let tParams = pData;
        let tPoints = new Array();
        for (let tEP of tParams.ElementPoints) {
            let tP = new Vector3(0, 0, 0);
            tP.x = tEP.x;
            tP.z = tEP.z;
            tPoints.push(tP);
        }
        if (tPoints.length === 2)
            this.setPoints(tPoints);
    }
    setPoints(pPoints) {
        if (pPoints.length !== 2)
            return;
        if (pPoints[0] == null || pPoints[1] == null)
            return;
        let tL1 = Vector3.Distance(pPoints[0], pPoints[1]);
        if (tL1 < 0.05)
            return;
        this.mPoints = [];
        for (let tPoint of pPoints) {
            let tP = new Vector3(0, 0, 0);
            tP.x = tPoint.x;
            tP.z = tPoint.z;
            this.mPoints.push(tP);
        }
        this.mRoomElement.Params.ElementPoints = this.mPoints;
        this.mRoomElement.setClosedPolygon(true);
    }
    drawRadiusLine(pParent) {
        let tactTool = this.mRoomManager.app.tools.activeTool;
        if (this.mRoomElement.interactorsVisible || tactTool instanceof Area2D) {
            let tPoints = new Array();
            tPoints.push(new Vector3(0, 0, 0));
            tPoints.push(new Vector3(this.mRoomElement.width * 0.5, 0, 0));
            let tRadiusLine = CreateLines("", { points: tPoints }, this.mScene);
            tRadiusLine.color = Color3.FromHexString("#000000");
            tRadiusLine.parent = pParent;
            tRadiusLine.isPickable = false;
            tRadiusLine.renderingGroupId = 1;
            ShadowGenerator.disableMeshShadow(tRadiusLine);
            this.prepare3dMesh(tRadiusLine);
        }
    }
    calcLenght(pPoints) {
        let tRadius = Vector3.Distance(pPoints[0], pPoints[1]);
        this.mPerimeter = 2 * Math.PI * tRadius;
        this.calcArea(pPoints);
    }
    calcArea(pPoints) {
        let tarea = 0;
        if (pPoints.length < 2)
            return;
        let tRadius = Vector3.Distance(pPoints[0], pPoints[1]);
        tarea = Math.PI * (tRadius * tRadius);
        this.mArea = tarea;
    }
    calcSize(pPoints) {
        if (pPoints.length === 0)
            return;
        let tminX = pPoints[0].x;
        let tminY = pPoints[0].z;
        let tmaxX = pPoints[0].x;
        let tmaxY = pPoints[0].z;
        for (let tPoint of pPoints) {
            tminX = Math.min(tPoint.x, tminX);
            tmaxX = Math.max(tPoint.x, tmaxX);
            tminY = Math.min(tPoint.z, tminY);
            tmaxY = Math.max(tPoint.z, tmaxY);
        }
        this.mWidth = Vector3.Distance(this.mRoomElement.Params.ElementPoints[0], this.mRoomElement.Params.ElementPoints[1]) * 2;
        this.mDepth = this.mWidth;
        this.mRoomElement.setWidth(this.mWidth, false, false);
        this.mRoomElement.setDepth(this.mDepth, false, false);
        this.mminPoint = new Vector2(tminX, tminY);
        this.mmaxPoint = new Vector2(tmaxX, tmaxY);
    }
    getCorrectedPolyPath() {
        let tP = this.getPolygon(false);
        if (Util.vectorEquals3(tP[0], tP[tP.length - 1]))
            tP.pop();
        if ((tP.length > 3) && (Util.vectorEquals3(tP[tP.length - 1], tP[tP.length - 2]))) {
            tP.pop();
        }
        tP = Util.correctPolygonDirection3(tP);
        return (tP);
    }
    // // tslint:disable-next-line:cyclomatic-complexity
    // private createOffsetCSG(pBasePoly: Array<Vector3>): ElementGeometry.CAGCSGPack
    // {
    //     let tRes = {} as ElementGeometry.CAGCSGPack;
    //     tRes.CAG = null;
    //     tRes.CSG = null;
    //     const tHillOffset: number = this.mRoomElement.Params.hillOffset;
    //     const tHillType = this.mRoomElement.Params.terrainType;
    //     if (tHillType === "Flat") {
    //         return (tRes);
    //     }
    //     let tbasePolygon = pBasePoly;
    //     let toffsetPoints: Array<Vector3> = offset(tbasePolygon, (tHillType === 'Top' ? tHillOffset : -tHillOffset));
    //     if (toffsetPoints.length !== tbasePolygon.length) {
    //         return (tRes);
    //     }
    //     // offset plane
    //     let tPointsOffset = new Array<CSG.Vector2D>();
    //     let tCAGOffset: CAG | null = null;
    //     toffsetPoints = Util.correctPolygonDirection3(toffsetPoints);
    //     this.limitOffsetDistance();
    //     if (tHillType === 'Bottom') {
    //         for (let tP1 of toffsetPoints) {
    //             tP1.addInPlace(this.mRoomElement.Params.hillTopOffset);
    //         }
    //     }
    //     if (toffsetPoints.length === tbasePolygon.length) {
    //         this.mHillPoints_Offset = toffsetPoints;
    //     }
    //     for (let tPoint of toffsetPoints) {
    //         tPointsOffset.push(new CSG.Vector2D(tPoint.x, tPoint.z));
    //     }
    //     if (toffsetPoints.length === tbasePolygon.length) {
    //         tCAGOffset = CAG.fromPointsNoCheck(tPointsOffset);
    //     }
    //     if (tCAGOffset == null || (tCAGOffset.isSelfIntersecting())) {
    //         return (tRes);
    //     }
    //     let tCSGOffset = Util.CAG2CSG(tCAGOffset);
    //     tRes.CAG = tCAGOffset;
    //     tRes.CSG = tCSGOffset;
    //     return (tRes);
    // }
    centerCircle(pPoints) {
        if (pPoints.length === 0)
            return;
        let tminX = pPoints[0].x;
        let tminY = pPoints[0].y;
        let tmaxX = pPoints[0].x;
        let tmaxY = pPoints[0].y;
        for (let tPoint of pPoints) {
            tminX = Math.min(tPoint.x, tminX);
            tmaxX = Math.max(tPoint.x, tmaxX);
            tminY = Math.min(tPoint.y, tminY);
            tmaxY = Math.max(tPoint.y, tmaxY);
        }
        let tcenter = new Vector3(tmaxX - ((tmaxX - tminX) * 0.5), 0, tmaxY - ((tmaxY - tminY) * 0.5));
        for (let tPoint of pPoints) {
            tPoint.subtractInPlace(Util.to2d(tcenter));
        }
    }
    circlePointList() {
        let tRes = new Array();
        let tDist = Vector3.Distance(this.mPoints[0], this.mPoints[1]);
        let tRadius = tDist > 0 ? tDist : 0.001;
        // let tCosA: number;
        // let tSinA: number;
        // for (let i = 0; i < 60; i++) {
        //     let tDeg = degToRad(i * 6.0 - 360);
        //     tCosA = Math.cos(tDeg);
        //     tSinA = Math.sin(tDeg);
        //     tRes.push(new Vector2(tCosA * tRadius - (tRadius * 0.5), tSinA * tRadius - (tRadius * 0.5)));
        // }
        // this.centerCircle(tRes);
        const tCAG = CAG.circle({ radius: tRadius, resolution: 60 });
        const tpoints = tCAG.toPoints();
        for (let tP of tpoints) {
            tRes.push(new Vector2(tP.x, tP.y));
        }
        return (tRes);
    }
    createCircle(pParent) {
        if (this.mPoints.length === 0)
            return (null);
        this.mHillPoints_Base = this.getCorrectedPolyPath();
        let tRes = this.createCSG_Hill(pParent, this.mHillPoints_Base, this.mcanCreateHill);
        this.mHillPoints_Offset = tRes.offsetPoints;
        this.mcanCreateHill = tRes.canCreateHill;
        return (tRes.mesh);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    createHill(pParent) {
        const basePoints = this.mHillPoints_Base;
        const offsetPoints = this.mHillPoints_Offset;
        const height = this.mRoomElement.Params.hillHeight;
        const splineType = this.mRoomElement.Params.terrainType;
        if (this.mHillPoints_Offset == null || this.mHillPoints_Base == null ||
            basePoints == null || offsetPoints == null || splineType === 'Flat' ||
            !this.mcanCreateHill) {
            return (null);
        }
        const canRibbon = offsetPoints.length === basePoints.length;
        if (!canRibbon) {
            newError('Unstable calculation', 'expansion failed');
            return (null);
        }
        let topPolygon = [];
        let bottomPolygon = [];
        if (splineType === 'Top') {
            topPolygon = this.mHillPoints_Base;
            bottomPolygon = this.mHillPoints_Offset;
        }
        if (splineType === 'Bottom') {
            topPolygon = this.mHillPoints_Offset;
            bottomPolygon = this.mHillPoints_Base;
        }
        const curve = this.curveFunction(this.mRoomElement.Params.hillProfile);
        const steps = getSteps(curve);
        const inters = steps.map((x, i) => getInterpolatedPolygon(bottomPolygon, topPolygon, x)
            .map((y) => { y.y += curve[i] * height; return y; }));
        const side = CreateRibbon('circle_hill_side', {
            pathArray: inters,
            closePath: true,
            sideOrientation: Mesh.BACKSIDE,
            updatable: true
        }, this.mScene);
        let positions = side.getVerticesData(VertexBuffer.PositionKind);
        if (positions != null) {
            let minX = Infinity;
            let minZ = Infinity;
            let maxX = -Infinity;
            let maxZ = -Infinity;
            let x = 0;
            let z = 0;
            let uvs = [];
            for (var i1 = 0; i1 < positions.length / 3; i1++) {
                x = positions[3 * i1];
                z = positions[3 * i1 + 2];
                minX = Math.min(x, minX);
                minZ = Math.min(z, minZ);
                maxX = Math.max(x, maxX);
                maxZ = Math.max(z, maxZ);
                uvs.push(x, z);
            }
            for (let i2 = 0; i2 < uvs.length / 2; i2++) {
                // uvs[2 * i2] = (uvs[2 * i2] - minX) / ((maxX - minX) * 0.15);
                // uvs[2 * i2 + 1] = (uvs[2 * i2 + 1] - minZ) / ((maxZ - minZ) * 0.15);
                uvs[2 * i2] = (uvs[2 * i2] - minX);
                uvs[2 * i2 + 1] = (uvs[2 * i2 + 1] - minZ);
            }
            side.updateVerticesData(VertexBuffer.UVKind, uvs);
        }
        side.parent = pParent;
        side.material = this.mRoomElement.localMaterial;
        side.receiveShadows = true;
        return side;
    }
}
function getSteps(points) {
    const step = 1 / (points.length - 1);
    const res = [];
    for (let i = 0; i < points.length; i++) {
        res.push(i * step);
    }
    return res;
}
function getInterpolatedPolygon(a, b, n) {
    const res = [];
    for (let i = 0; i < a.length; i++) {
        res.push(b[i].subtract(a[i]).scale(n).add(a[i]));
    }
    return res;
}
